import type { RouteRecordRaw } from 'vue-router';

export const SETTLEMENT_ROUTER: RouteRecordRaw[] = [
  {
    path: '/adjustment/settlement',
    component: () => import('@/components/layout/Default.vue'),
    meta: { requiresAuth: true },
    redirect: '/adjustment/settlement/list',
    children: [
      {
        path: 'list',
        component: () => import('@/modules/adjustment/settlement/views/List.vue'),
        name: 'Settlement List',
        meta: {
          title: '정산목록',
        },
      },
    ],
  },
];
